import { INTERVAL_BY_HOUR } from 'helpers/graph';
import {
    FETCH_PRODUCT_OCCUPANCY,
    FETCH_PRODUCT_OCCUPANCY_FAILURE,
    FETCH_PRODUCT_OCCUPANCY_SUCCESS,
} from 'store/actions/types';

const initialState = {
    data: null,
    interval: INTERVAL_BY_HOUR,
    loading: false,
    offset: 0,
    page: 1,
    params: null,
    size: 12,
    total: 0,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCT_OCCUPANCY:
            return {
                ...state,
                loading: true,
            };
        case FETCH_PRODUCT_OCCUPANCY_FAILURE:
            return {
                ...state,
                data: null,
                loading: false,
            };
        case FETCH_PRODUCT_OCCUPANCY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                params: action.response,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/products/productOccupancyReducer.js